module.exports = __webpack_public_path__ + "static/media/btn_back.d18b7ac4.svg";